import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=60496878&scoped=true&"
import script from "./HeatMap.vue?vue&type=script&lang=js&"
export * from "./HeatMap.vue?vue&type=script&lang=js&"
import style0 from "./HeatMap.vue?vue&type=style&index=0&id=60496878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60496878",
  null
  
)

export default component.exports